<template>
  <Menu offset-y class="mx-2">
    <template v-slot:menu-btn="{ on, attrs }">
      <Button v-ripple="false" outlined class="filter-actions-btn" v-bind="attrs" v-on="on" :title="$t('actions')">
        <template #icon>
          <span class="menu-arrow" :class="attrs['aria-expanded'] !== 'false' ? 'app-menu-active' : ''"></span>
        </template>
      </Button>
    </template>
    <template #menu-list>
      <v-list>
        <v-list-item>
          <v-list-item-title> Export</v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-list-item-title> Import</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </Menu>
</template>

<script>
export default {
  name: "AppFilterActions",
};
</script>
